import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	clearAdvanceFilter,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../../../../store/action/advanceFilter';
import { getFiltersParams } from '../../../../../helper';
import { toast } from 'react-toastify';
import {
	changeCustomerStatus,
	deleteCustomer,
	getCustomerList,
} from '../../../../../services/customers';
import { hasPermission } from '../../../../../utils/controller';

export default function useCustomer() {
	const [bulkAction, setBulkAction] = useState([]);
	const [isMarkAsStatus, setIsMarkAsStatus] = useState({
		isModelOpen: false,
		isStatus: null,
	});
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [selectedCustomerListForDelete, setSelectedCustomerListForDelete] = useState([]);
	const [deselectRows, setDeselectRows] = useState(null);
	const [headerDropDown, setHeaderDropDown] = useState('All Customers');
	const [sortDirection, setSortDirection] = useState({ id: 'asc' });
	const suburl = localStorage.getItem('suburl');
	const dispatch = useDispatch();
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const [customersList, setCustomers] = useState({
		data: [],
		totalPages: 0,
		currentPage: 1,
	});
	const [customersParams, setCustomersParams] = useState({
		page: 1,
		page_size: 20,
		order_by: 'desc',
		sort_by: 'created_at',
		filters: {},
	});
	const [isLoading, setLoading] = useState(false);
	const [isLoader, setLoader] = useState(false);
	const navigate = useNavigate();
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};

	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];

		if (key !== 'status') {
			const { customers } = await getCustomerList({ ...customersParams, page_size: 1000 });

			selectInputData = customers
				?.filter((customer) => customer[key])
				?.map((customer) => ({
					key: customer[key],
					value: customer[key],
				}));
		} else {
			selectInputData = [
				{ key: 'Active Customers', value: 'Active Customers' },
				{ key: 'Inactive Customers', value: 'Inactive Customers' },
				{ key: 'Duplicate Customers', value: 'Duplicate Customers' },
			];
		}
		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}

	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) {
				return;
			}
			if (params.status) {
				setHeaderDropDown(params.status);
			}

			const updatedParams = { ...params };

			if (updatedParams.status === 'Active Customers') {
				updatedParams.status = 1;
			}

			if (updatedParams.status === 'Inactive Customers') {
				updatedParams.status = 2;
			}

			if (updatedParams.status === 'Draft Customers') {
				updatedParams.status = 0;
			}

			if (updatedParams.status === 'Duplicate Customers') {
				updatedParams.status = 4;
			}

			var { customers, total_pages } = await getCustomerList({
				order_by: advanceFilterOrderby,
				sort_by: advanceFilterSortBy,
				page: advanceFilterPage,
				page_size: advanceFilterPageSize,
				filters: updatedParams,
			});
			const customerLists = mappedTableData(customers);
			setBulkAction([]);
			setCustomers((prev) => ({
				...prev,
				data: customerLists,
				totalPages: total_pages,
				currentPage: 1,
			}));
			dispatch(setAdvanceFilterTotalPage({ totalPages: total_pages }));
			setIsAdvanceFilterOpen(false);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		}
	}
	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'status') {
				optionsList = [
					{ key: 'Active Customers', value: 'Active Customers' },
					{ key: 'Inactive Customers', value: 'Inactive Customers' },
				];
			} else {
				const { customers } = await getCustomerList({
					page_size: 1000,
					filters: {
						key: value,
					},
				});
				optionsList = customers?.map((customers) => ({
					key: customers[key],
					value: customers[key],
				}));
			}

			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	const onRowClick = (id) => {
		if (id && hasPermission('sales.customers.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/customers-details/${id}`);
		}
	};

	const FilterDatalist = (param, value, dropDownData) => {
		if (isAdvanceFilterApplied && dropDownData === 'All Customers') {
			dispatch(clearAdvanceFilter());
			setHeaderDropDown('All Customers');
			return;
		}
		setHeaderDropDown(dropDownData);

		const updatedSelectedInput = selectedInputs.map((input) => {
			if (input.key === 'status') {
				return {
					...input,
					value: dropDownData,
				};
			}
			return input;
		});
		dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
		dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
		dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
		const selectInputData = [
			{ key: 'Active Customers', value: 'Active Customers' },
			{ key: 'Inactive Customers', value: 'Inactive Customers' },
			{ key: 'Duplicate Customers', value: 'Duplicate Customers' },
		];
		dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.sort_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.sort_by]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ order_by: newDirection, sort_by: param.sort_by }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setCustomersParams((prev) => ({
				...prev,
				order_by: newDirection,
				sort_by: param.sort_by,
			}));
		}
	};

	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page }));
		} else {
			setCustomersParams((prev) => ({
				...prev,
				page,
			}));
		}
	};

	const getModalContent = () => {
		return (
			<div>
				<p
					style={{ fontWeight: '600' }}
					className="ConfirmationText"
				>
					Are you sure you want to mark these {bulkAction.length} customers as{' '}
					{isMarkAsStatus.isStatus === 1 ? 'Active' : 'Inactive'}?
				</p>
				<div
					style={{
						padding: '0px 10px',
					}}
				>
					{customersList.data
						.filter((customer) => bulkAction.includes(customer.id))
						.map((customer, index) => (
							<p key={customer.id}>
								{index + 1}. {JSON.parse(customer['name'])['name']}
							</p>
						))}
				</div>
			</div>
		);
	};

	async function handleBulkDelete() {
		try {
			if (bulkAction.length === 0) {
				toast.error('Please select customer!');
				return;
			}
			var body = JSON.stringify({
				ids: bulkAction,
			});
			await deleteCustomer(body);
			toast.success('Customers Deleted Successfully.');
			setIsDeleteModalOpen(false);
			setBulkAction([]);
			deselectRows && deselectRows();
			getCustomers();
		} catch (error) {
			toast.error(error?.message || 'Something went wrong');
		}
	}

	function handleOpenBulkDeleteCustomerModal() {
		const selectedVendorsList = customersList.data?.reduce((acc, item) => {
			if (bulkAction.includes(item.id)) {
				acc.push(JSON.parse(item['name'])['name']);
				return acc;
			}
			return acc;
		}, []);
		setSelectedCustomerListForDelete(selectedVendorsList);
		setIsDeleteModalOpen(true);
	}

	const triggerConfirmationModal = (status) => {
		setIsMarkAsStatus((prev) => ({
			isModelOpen: true,
			isStatus: status,
		}));
	};

	async function handleIsActiveStatus(status) {
		try {
			const formbody = {
				ids: bulkAction,
				status: status,
			};
			setLoader(true);
			await changeCustomerStatus(formbody);
			toast.success('Status Changes Successfully');
			setCustomersParams((prev) => ({
				...prev,
				filterBy: 'status',
				filterValue: headerDropDown === 'All Customers' ? null : status ? 0 : 1,
			}));
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader(false);
		}
	}

	const closeModal = () => {
		setIsMarkAsStatus((prev) => ({
			isModelOpen: false,
			isStatus: null,
		}));
	};

	const getCustomers = async () => {
		setLoading(true);
		var { customers, total_pages, page } = await getCustomerList(customersParams);
		const customerLists = mappedTableData(customers);
		setBulkAction([]);
		setCustomers((prev) => ({
			...prev,
			data: customerLists,
			totalPages: total_pages,
			currentPage: page,
		}));
		setLoading(false);
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.id,
				name:
					JSON.stringify({
						name: ele?.name,
						status: ele?.status,
						type: ele?.type,
					}) || 'N/A',
				EMAIL: ele?.email || 'N/A',
				MOBILE: ele?.mobile || 'N/A',
				RECEIVABLES: Number(ele?.receivables || 0).toFixed(2),
				'UNUSED CREDITS': Number(ele?.unused_credit_amount || 0).toFixed(2),
			};
		});
	}

	useEffect(() => {
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			getCustomers();
		}
	}, [customersParams, advanceFilterPage, isAdvanceFilterApplied]);

	return {
		user,
		customersList,
		suburl,
		handlePageChange,
		onRowClick,
		handleDeselectAll,
		FilterDatalist,
		sortDataList,
		handleOnFocusSelectedFilterInput,
		handleApplyFilters,
		searchSelectedInputItems,
		setIsAdvanceFilterOpen,
		isAdvanceFilterOpen,
		isAdvanceFilterApplied,
		selectedInputs,
		setBulkAction,
		bulkAction,
		triggerConfirmationModal,
		deselectRows,
		isLoading,
		isLoader,
		setHeaderDropDown,
		headerDropDown,
		dispatch,
		getModalContent,
		closeModal,
		isMarkAsStatus,
		handleIsActiveStatus,
		handleOpenBulkDeleteCustomerModal,
		isDeleteModalOpen,
		setIsDeleteModalOpen,
		selectedCustomerListForDelete,
		handleBulkDelete,
		sortDirection,
		advanceFilterPage,
		advanceFilterTotalPages,
		customersParams,
		setCustomersParams,
	};
}
